var React = require('react');

function TwitterInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"twitter","d":"M90.481,138.45c18.576,0,28.737-15.39,28.737-28.737,0-.437,0-.872-.03-1.306a20.55,20.55,0,0,0,5.039-5.228,20.16,20.16,0,0,1-5.8,1.589,10.135,10.135,0,0,0,4.44-5.586,20.241,20.241,0,0,1-6.413,2.452,10.109,10.109,0,0,0-17.212,9.211,28.674,28.674,0,0,1-20.815-10.552,10.107,10.107,0,0,0,3.127,13.482,10.024,10.024,0,0,1-4.584-1.264v.128a10.1,10.1,0,0,0,8.1,9.9,10.084,10.084,0,0,1-4.56.173,10.111,10.111,0,0,0,9.436,7.014A20.266,20.266,0,0,1,77.4,134.059a20.554,20.554,0,0,1-2.4-.146,28.593,28.593,0,0,0,15.481,4.529","transform":"translate(-75 -98.45)","fill":"#707070"}));
}

TwitterInline.defaultProps = {"width":"49.227","height":"40","viewBox":"0 0 49.227 40"};

module.exports = TwitterInline;

TwitterInline.default = TwitterInline;
